import { styled } from '@mui/material/styles';

export const KwFilterWrapper = styled('div')`
  display: flex;
  column-gap: 16px;
  margin-bottom: 30px;
  align-items: center;
`;
